export default __webpack_public_path__ + "static/background3x 1-bc95b9a7f022e97fc8ada2a782a86d5e.png";